import styled from 'styled-components';
import {Link as LinkS} from 'react-scroll';
import {Link as LinkR} from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import {FaTimes} from "react-icons/fa";

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 50%;
    height: 100%;
    background: #0d0d0d;
    display: grid;
    align-items: center;
    top: 0;
    right:0;
    transition: 0.4s ease-in-out;
    opacity: ${({isOpen})=>(isOpen? '90%':'0')};
    top: ${({isOpen})=>(isOpen? '0': '-100%')};
    
`

export const CloseIcon= styled(FaTimes)`
    color: #fff;
`
export const Icon = styled.div`
    position: absolute;
    top: 1.1rem;
    right: 1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`

export const SidebarWrapper = styled.div `
    color: #fff;
   
`
export const SidebarMenu= styled.ul`
    display:grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 80px);
    text-align: center;
    padding-right: 30px;

    @media screen and (max-width: 480px){
        grid-template-rows: repeat(6,60px);
    }
`

export const SidebarLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    text-decoration: none;
    color: #fff;
    cursor: pointer;
    position: relative;

&:hover{
    ${'' /* color: #01bf71; */}
    color:#FF9933;
    transition: 0.2s ease-in-out;
}
:before{
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 0;
        ${'' /* background-color: #FFF; */}
        background-color: #ffa852;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
    }
    :hover::before{
        visibility: visible;
        width: 100%;
    }
`

export const SideBtnWrap = styled.div `
    display: flex;
    justify-content: center;
    
`
export const ProfileTof = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;

   
`
export const UserBox = styled.div`
   margin-top: 20px;
   text-align: center;

    @media screen and (max-width: 480px){
    } 
`

export const SidebarRoute = styled(LinkR)`
    border-radius: 50px;
    background: linear-gradient( #806000,#ffe699);
    white-space: nowrap;
    padding: 16px 64px;
    color: #010606;
    
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    
    

    &.hover{
        transition: all 0.2s ease-in-out ;
        background: #fff;
        color: #010606; 
        background: linear-gradient( #4d3900,#ffe699);  
    }
    @media screen and (max-width: 375px){
    height: 40px;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
`